var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBusca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.998,
    height: 19.998,
    viewBox: "0 0 19.998 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.998,
    height: 19.998,
    transform: "translate(0 -0.91)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.02,17.009a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,17.02,17.009Zm0-14.569a6.07,6.07,0,1,0,6.07,6.07A6.07,6.07,0,0,0,17.02,2.44Z",
    transform: "translate(-6.086 -0.353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221,50.519A1.214,1.214,0,0,1,.352,48.45l.007-.007,4.565-4.565a1.241,1.241,0,1,1,1.724,1.785l-4.565,4.5A1.214,1.214,0,0,1,1.221,50.519Z",
    transform: "translate(0 -31.434)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBusca);
export default __webpack_public_path__ + "static/media/ico-busca.070d95f8.svg";
export { ForwardRef as ReactComponent };